import React, { useId } from 'react';
import './Logo.css';

const Logo = ({ variant = 'dark' }) => {
  const uid = useId().replace(/:/g, '');

  return (
    <span className={`brand-logo brand-logo-${variant}`}>
      <svg className="brand-logo-mark" viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id={`snTop-${uid}`} x1="12" y1="8" x2="52" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#5eead4" />
            <stop offset="100%" stopColor="#14b8a6" />
          </linearGradient>
          <linearGradient id={`snRight-${uid}`} x1="32" y1="20" x2="58" y2="56" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#0f766e" />
            <stop offset="100%" stopColor="#115e59" />
          </linearGradient>
        </defs>
        <path fill={`url(#snTop-${uid})`} d="M32 6L54 18.7 32 31.4 10 18.7Z" />
        <path fill={`url(#snRight-${uid})`} d="M32 31.4L54 18.7V43.3L32 56Z" />
        <path fill="#0B1520" d="M32 31.4L10 18.7V43.3L32 56Z" opacity="0.92" />
      </svg>
      <span className="brand-logo-text">
        <span className="brand-logo-name">
          <span className="brand-logo-soft">Soft</span>
          <span className="brand-logo-nova">nova</span>
        </span>
        <span className="brand-logo-sub">Web · Mobile · Digital</span>
      </span>
    </span>
  );
};

export default Logo;
